import React from "react";
import { Box, Tooltip } from "@mui/material";

interface Label {
  "@id"?: string;
  name: string;
  color?: string;
}

interface LabelDotsProps {
  labels: Label[];
}

const LabelDots: React.FC<LabelDotsProps> = ({ labels }) => {
  return (
    <Box display="flex" gap={0.5}>
      {labels && labels.map((label) => {
        const backgroundColor = label.color || "#DDD";
        const key = label["@id"] || label.name;

        return (
          <Tooltip key={key} title={label.name}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: backgroundColor,
                border: "1px solid #FFF",
              }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default LabelDots;